import { useState } from 'react'
import { Dialog } from '../ui/Dialog'
import { useSnapshot, useStation } from '../state/TelephonyProvider'
import { useCommand } from '../state/useCommand'
import { useDial } from '../state/useDial'
import { TelephonyCommandNames } from '../contract'
import { IconBackspace, IconPhone } from '../ui/icons'

const KEYS: Array<[string, string]> = [
  ['1', ''], ['2', 'ABC'], ['3', 'DEF'],
  ['4', 'GHI'], ['5', 'JKL'], ['6', 'MNO'],
  ['7', 'PQRS'], ['8', 'TUV'], ['9', 'WXYZ'],
  ['*', ''], ['0', '+'], ['#', '']
]

export function Dialpad({ onClose }: { onClose: () => void }) {
  const dial = useDial()
  const run = useCommand()
  const station = useStation()
  const { calls } = useSnapshot()
  const activeCall = calls.find((c) => c.extension === station.extension && c.status === 'connected')
  const [num, setNum] = useState('')
  const [dtmfMode, setDtmfMode] = useState(false)
  const sendingDtmf = dtmfMode && !!activeCall

  const press = (k: string) => {
    setNum((n) => n + k)
    if (sendingDtmf && activeCall) {
      void run({ command: TelephonyCommandNames.SendDtmf, params: { channel: activeCall.channel, digits: k } })
    }
  }
  const backspace = () => setNum((n) => n.slice(0, -1))
  const placeCall = () => { if (num.trim()) { dial(num); onClose() } }

  return (
    <Dialog
      title={sendingDtmf ? 'Keypad — sending DTMF' : 'Dial pad'}
      onClose={onClose}
      footer={
        sendingDtmf ? (
          <button className="sb-btn-ghost" onClick={onClose}>Done</button>
        ) : (
          <>
            <button className="sb-btn-ghost" onClick={onClose}>Cancel</button>
            <button className="sb-btn-primary" disabled={!num.trim()} onClick={placeCall}>
              <IconPhone size={15} stroke={1.75} /> Call
            </button>
          </>
        )
      }
    >
      {activeCall ? (
        <div className="sb-seg" role="group" aria-label="Keypad mode">
          <button className={!dtmfMode ? 'on' : ''} onClick={() => setDtmfMode(false)}>Dial new</button>
          <button className={dtmfMode ? 'on' : ''} onClick={() => { setDtmfMode(true); setNum('') }}>Send DTMF</button>
        </div>
      ) : null}

      <div className="sb-dial-display">
        <input
          className="sb-input" inputMode="tel" placeholder={sendingDtmf ? 'Tones sent live' : 'Number'}
          value={num} onChange={(e) => setNum(e.target.value)} aria-label="Number"
        />
        <button className="sb-iconbtn" aria-label="Backspace" onClick={backspace}>
          <IconBackspace size={18} stroke={1.75} />
        </button>
      </div>

      <div className="sb-dialpad">
        {KEYS.map(([k, sub]) => (
          <button key={k} className="sb-dialkey" onClick={() => press(k)} aria-label={`Key ${k}`}>
            <span className="num">{k}</span>
            <span className="sub">{sub}</span>
          </button>
        ))}
      </div>
      {sendingDtmf ? <p className="sb-note">Tones are sent to your active call as you tap.</p> : null}
    </Dialog>
  )
}
